import { OnInit } from '@angular/core';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { GLOBAL } from 'src/app/services/global';
var Formulario43Component = /** @class */ (function () {
    function Formulario43Component() {
        this.htmlcanvas = html2canvas;
        this.nombreMuni = GLOBAL.nombreMuni;
        this.region = GLOBAL.region;
        //contadores
        this.sup_proy_total = 0;
        this.cant = 0;
        this.sup_porcentajes = 0;
        this.pages = [1, 2, 3];
    }
    Formulario43Component.prototype.ngOnInit = function () {
    };
    Formulario43Component.prototype.ngAfterContentChecked = function () {
        this.ngAfterContentInit();
    };
    Formulario43Component.prototype.ngDoCheck = function () {
        this.sup_proy_total = 0;
        //LOTES ENAJENAR
        if (JSON.parse(localStorage.getItem("lotes_enajenar"))) {
            if (JSON.parse(localStorage.getItem("lotes_enajenar")).length > 0) {
                this.lotes_enajenar = JSON.parse(localStorage.getItem("lotes_enajenar"));
            }
            else {
                localStorage.setItem("lotes_enajenar", JSON.stringify([]));
                this.lotes_enajenar = [{ lotes_enajenar: '', num_lotes: '', sup_lotes_enajenar: '', hoja_anexa: '' }];
            }
        }
        for (var i = 0; i < this.lotes_enajenar.length; i++) {
            this.sup_proy_total = this.sup_proy_total + parseInt(this.lotes_enajenar[i].sup_lotes_enajenar);
        }
    };
    Formulario43Component.prototype.ngAfterContentInit = function () {
        //PROPIEDAD
        if (JSON.parse(localStorage.getItem("propiedad"))) {
            this.propiedad = JSON.parse(localStorage.getItem("propiedad"));
        }
        else {
            localStorage.setItem("propiedad", JSON.stringify([]));
            this.propiedad = [{ rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa: '', direc_complemento: '', direc_compl_num: '', loteo: '', manzana: '', plano: '', recordId: '' }];
        }
        //PROPIETARIOS
        if (JSON.parse(localStorage.getItem("propietarios"))) {
            this.propietarios = JSON.parse(localStorage.getItem("propietarios"));
        }
        else {
            localStorage.setItem("propietarios", JSON.stringify([]));
            this.propietarios = [{ rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' }];
        }
        //PERMISO NOTARIADO
        if (JSON.parse(localStorage.getItem("permiso_notariado"))) {
            this.permiso_notariado = JSON.parse(localStorage.getItem("permiso_notariado"));
        }
        else {
            localStorage.setItem("permiso_notariado", JSON.stringify([]));
            this.permiso_notariado = [{ acreditacion: '', fecha: null, escritura: null, notario: '' }];
        }
        //ARQUITECTOS
        if (JSON.parse(localStorage.getItem("arquitectos"))) {
            this.arquitectos = JSON.parse(localStorage.getItem("arquitectos"));
        }
        else {
            localStorage.setItem("arquitectos", JSON.stringify([]));
            this.arquitectos = [{ rut: '', nombre: '', mail: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_complemento: '', direccion_num: '', comuna: '', fono: '', fax: '', patente: '', recordId: '' }];
        }
        //REGISTRO DE BIENES
        if (JSON.parse(localStorage.getItem("registro_bienes"))) {
            this.registro_bienes = JSON.parse(localStorage.getItem("registro_bienes"));
        }
        else {
            localStorage.setItem("registro_bienes", JSON.stringify([]));
            this.registro_bienes = [{ inscrito: '', numero: '', anio: '', bienes: '' }];
        }
        //LOTES ENAJENAR
        if (JSON.parse(localStorage.getItem("lotes_enajenar"))) {
            this.lotes_enajenar = JSON.parse(localStorage.getItem("lotes_enajenar"));
        }
        else {
            localStorage.setItem("lotes_enajenar", JSON.stringify([]));
            this.lotes_enajenar = [{ lotes_enajenar: '', num_lotes: '', sup_lotes_enajenar: '', hoja_anexa: '' }];
        }
        //TIPO GARANTIA
        if (JSON.parse(localStorage.getItem("tipo_garantia"))) {
            this.tipo_garantia = JSON.parse(localStorage.getItem("tipo_garantia"));
        }
        else {
            localStorage.setItem("tipo_garantia", JSON.stringify([]));
            this.tipo_garantia = [{ tipo_garantia: '' }];
        }
        //CARACTERISTICAS SOL
        if (JSON.parse(localStorage.getItem("caract_sol"))) {
            this.caract_sol = JSON.parse(localStorage.getItem("caract_sol"));
        }
        else {
            localStorage.setItem("caract_sol", JSON.stringify([]));
            this.caract_sol = [{ num_reso_perm: '', fecha_reso_perm: null, tipo_garantia: '' }];
        }
        //CUENTA CON MOD
        if (JSON.parse(localStorage.getItem("cuenta_con_mod"))) {
            this.cuenta_con_mod = JSON.parse(localStorage.getItem("cuenta_con_mod"));
        }
        else {
            localStorage.setItem("cuenta_con_mod", JSON.stringify([]));
            this.cuenta_con_mod = [{ mod_aprob: '', numero: '', fecha: null }];
        }
    };
    Formulario43Component.prototype.captureScreen = function () {
        var _this = this;
        var pdf = new jspdf('p', 'mm', 'a4');
        this.htmlcanvas(document.getElementById("page1")).then(function (canvas) {
            var contentDataURL = canvas.toDataURL('image/png');
            pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297);
        });
        this.htmlcanvas(document.getElementById("page2")).then(function (canvas) {
            var contentDataURL = canvas.toDataURL('image/png');
            pdf.addPage();
            pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297);
        });
        this.htmlcanvas(document.getElementById("page3")).then(function (canvas) {
            var contentDataURL = canvas.toDataURL('image/png');
            pdf.addPage();
            pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297);
        });
        setTimeout(function () {
            pdf.save(_this.propietarios[0].rut + '.pdf');
            // pdf.save('prueba.pdf')
        }, 6000);
    };
    return Formulario43Component;
}());
export { Formulario43Component };
